import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {IObject} from "../models/models";

@Injectable({
  providedIn: 'root'
})
export class ExpertiseService {
  api = environment.apiUrl+'Expertise/';
  api2 = environment.apiUrl;
/*  api = 'https://devbaiterek.idet.kz/mio-back/Expertise/';
  api2 = 'https://devbaiterek.idet.kz/mio-back/';*/
  fileName = 'Согласие заказчика проекта';
  fileExtension = 'pdf';

  constructor(private http: HttpClient) {
  }

  getSampleSignInfo(): Observable<ISampleSignInfo> {
    return this.http.get<ISampleSignInfo>(`${this.api}GetSampleSignInfo`);
  }

  getSamplePdfFile() {
    return this.http.get(`${this.api}GetSamplePdfFile`, {responseType: 'blob'});
  }

  uploadSignedSamplePdfFile(livingComplexID: number, file: any) {
    const form: FormData = new FormData();
    form.append('LivingComplexID', livingComplexID.toString());
    form.append('Attachment', file);
    return this.http.post(this.api + 'UploadSignedSamplePdfFile', form);
  }


  getConsentFormPdf(obj: IGetConsentFormPdfInput) {
    return this.http.post(`${this.api}GetConsentFormPdf`, obj, {responseType: 'blob'});
  }

  uploadSignedConsentPdfFile(object: ISignedConsentPdfFileModelMio): Observable<IUploadSignedConsentPdfFileResult> {
    const form: FormData = new FormData();
    for (const objectKey in object) {
      if (objectKey === 'attachment') {
        form.append(objectKey, object[objectKey], object[objectKey]['name']);
      } else {
        form.append(objectKey, object[objectKey]);
      }
    }
    return this.http.post<IUploadSignedConsentPdfFileResult>(`${this.api}UploadSignedConsentPdfFile`, form);
  }

  checkExpertise(docDate: string, docNumber: string, fileID: number, expertiseID: number): Observable<ICheckExpertiseResult> {
    return this.http.get<ICheckExpertiseResult>(`${this.api}CheckStateExpertise?docDate=${docDate}&docNumber=${docNumber}&fileID=${fileID}&expertiseID=${expertiseID}`);
  }

  acceptConclusionFile(docDate: string, docNumber: string, fileID: number, expertiseID: number): Observable<ICheckExpertiseResult> {
    return this.http.get<ICheckExpertiseResult>(`${this.api}AcceptConclusionFile?docDate=${docDate}&docNumber=${docNumber}&fileID=${fileID}&expertiseID=${expertiseID}`);
  }

  generateFileLink(blobContent: Blob) {
    let blob = new Blob([blobContent], {type: 'application/octet-stream'});
    return window.URL.createObjectURL(blob);
  }

  saveFile(blobContent: Blob, fileName: string) {
    let blob = new Blob([blobContent], { type: 'application/octet-stream' });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExpertiseFile(body: IDownloadExpertiseFile, fileName:string = 'file') {
    let params = new HttpParams();
    params = params.append("fileID", body.fileID.toString());
    params = params.append("expertiseID", body.expertiseID.toString());
    params = params.append("isKenml", body.isKenml.toString());
    params = params.append("remotePSD", body.remotePSD.toString());
    return this.http.get(this.api + `DownloadExpertisesFile`, {params, responseType: 'blob'}).subscribe(res => {
      this.saveFile(res, fileName);
    });
  }

  uploadExpertiseConclusionFile(expertiseID: number, attachment: File, name: string): Observable<IUploadExpertiseConclusionFile> {
    const form: FormData = new FormData();
    form.append('expertiseID', expertiseID.toString());
    form.append('attachment', attachment, name);
    return this.http.post<IUploadExpertiseConclusionFile>(`${this.api}UploadExpertiseConclusionFile`, form);
  }

  createFileName(documentNumber: string) {
    return this.fileName + '_' + documentNumber.replace('/', '-') + '.' + this.fileExtension;
  }

  updateExpertise(expertise: IUpdateExpertise) {
    return this.http.post(`${this.api}UpdateExpertise`, expertise)
  }

  uploadExpertise(body: IUploadExpertiseBody): Observable<IUploadExpertiseRes> {
    let url = "UploadExpertise";
    const formData: FormData = new FormData();

    formData.append("LivingComplexID", body.livingComplexID.toString());
    formData.append("regionID", body.regionID.toString());
    formData.append("ExpertiseType", body.expertiseType.toString());
    formData.append("IsIntegration", body.isIntegration.toString());
    formData.append("IsActive", body.isActive.toString());

    if (body.documentNumber) {
      formData.append("DocumentNumber", body.documentNumber.toString());
    }
    if (body.documentDate) {
      formData.append("DocumentDate", body.documentDate.toString());
    }
    if (body.file) {
      formData.append("uploadedFile", body.file, body.file.name);
      formData.append("FileExtension", body.fileExtension);
    }

    return this.http.post<IUploadExpertiseRes>(this.api + url, formData);
  }

  getExpertiseTypes(): Observable<IDictionary[]> {
    let url = "Info/ExpertiseTypes";
    return this.http.get<IDictionary[]>(this.api2 + url, {});
  }

  getExpertises(id: number): Observable<IExpertiseDoc[]> {
    let params = new HttpParams();
    params = params.append("LivingComplexID", id.toString());
    let url = "GetExpertises";

    return this.http.get<IExpertiseDoc[]>(this.api + url, {
      headers: new HttpHeaders({
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      params
    });
  }

  getObject(livingComplexID: number): Observable<IObject> {
    return this.http.get<IObject>(`${this.api2}LivingComplexes/Get?livingComplexID=${livingComplexID}`);
  }

  getExpertiseFiles(expertiseID: number): Observable<IMaterialFileGroup> {
    return this.http.get<IMaterialFileGroup>(`${this.api}GetExpertiseFiles?expertiseID=${expertiseID}`);
  }

  downloadPsdFile(body: IDownloadExpertiseFile) {
    const params = this.transparentPsdFile(body);
    return this.http.get(this.api + `DownloadExpertisesFile`, {params, responseType: 'blob'}).subscribe(res => {
      this.downLoadFile(res, body.fileName, body.groupID, res && res.type);
    });
  }


  transparentPsdFile(body: IDownloadExpertiseFile) {
    let params = new HttpParams();
    params = params.append("fileID", body.fileID.toString());
    params = params.append("expertiseID", body.expertiseID.toString());
    params = params.append("isKenml", body.isKenml.toString());
    params = params.append("remotePSD", body.remotePSD.toString());
    return params;
  }

  downLoadFile(data: any, name: string, groupID: number, type: string) {
    var a = document.createElement("a");
    let blob;
    let extension: string;
    const fileExtension = name.split('.');

    if (groupID === ExpertiseGroupsEnum.Kenml) {
      extension = 'kenml';
      blob = new Blob([data], {type});
    } else if (groupID !== ExpertiseGroupsEnum.Kenml) {
      extension = fileExtension && fileExtension.length > 1 ? fileExtension[1] : 'pdf';
      blob = new Blob([data], {type: "application/pdf"});
    }

    a.href = URL.createObjectURL(blob);
    a.download = name + (fileExtension && fileExtension.length > 1 ? '' : '.' + extension);
    a.click();
  }

  deleteFile(object: IDeletePsdFile) {
    const params = new HttpParams()
      .set('fileID', object.fileID)
      .set('expertiseID', object.expertiseID)
      .set('isKenml', object.isKenml)
      .set('isPSOPortal', object.isPSOPortal)
    return this.http.delete(`${this.api2}PsdFiles/DeleteFile`, {params});
  }

  uploadPsdFiles(body: IUploadPsdFile): Observable<IUploadPsdFileResponse[]> {
    let url = "PsdFiles/UploadFiles";
    const formData: FormData = new FormData();
    formData.append("LivingComplexID", body.livingComplexID.toString());
    formData.append("expertiseID", body.expertiseID.toString());
    formData.append("groupID", body.groupID.toString());
    formData.append("regionID", body.regionID.toString());
    if (body.files && body.files.length) {
      for (let i = 0; i < body.files.length; i++) {
        formData.append("uploadedFile" + i, body.files[i]);
      }
    }
    return this.http.post<IUploadPsdFileResponse[]>(this.api2 + url, formData);
  }


}

export interface IGetConsentFormPdfInput {
  objectName: string;
  conclusionDate: string;
  conclusionNumber: string;
}

export interface ISignedConsentPdfFileModelMio {
  expertiseId: number;
  livingComplexID: number;
  documentNumber: string;
  documentDate: string;
  expertiseType: number;
  isIntegration: boolean;
  isActive: boolean;
  attachment: File;
  regionID: number;
}

export interface IUploadSignedConsentPdfFileResult {
  authorConsentFileID: number;
  expertiseID: number;
  fileName: string;
  errorStatus: number;
  responseType: any;
}

export interface ISampleSignInfo {
  serialNumber: string;
  orgUnitName: string;
  orgName: string;
  notAfter: string;
  allInfo: string;
  text?: string;
  bool?: boolean;
}

export interface IUploadExpertiseConclusionFile {
  errorStatus: number;
  responseType: any;
  conclusionFileID: number;
  fileName: string;
}

export interface ICheckExpertiseResult {
  conclusionFileID: number;
  errorStatus: number;
  fileName: string;
  objectTitle: string;
  responseType: any;
}

export interface IExpertiseDoc {
  id: number | null;
  date: string | null;
  number: string | null;
  expertiseType?: number;
  expertiseTypeTitle?: string;
  hasConclusion: boolean;
  hasKenml: boolean;
  hasPSD: boolean;
  hasPermission: boolean;
  isActive: boolean;
  isConstantPSO?: boolean;
  isDeleted?: boolean;
  isIntegration?: boolean;
  queueStatus?: number;
  statusDescription?: string;
  conclusionInfo?: IExpertiseFile;
  kenmlFiles?: IExpertiseFile[];
  otherFiles?: IExpertiseFile[];
  loaded?: boolean;
  isEdit?: boolean;
  authorConsentFileInfo?: ExpertiseFileInfoNew;
  conclusionFileInfo?: ExpertiseFileInfoNew;
  mssg?: string;
}

export interface IExpertiseFile {
  fileDate: string;
  fileID: number;
  fileName: string;
  groupID: number;
  isIntegration?: boolean;
  isKenml?: boolean;
  isActive?: boolean;
  loading?: boolean;
  docNumber?: string;
  docDate?: string;
  error?: boolean;
  message?: string;
  remotePSD?: boolean;
  expertiseID?: number;
}

export interface ExpertiseFileInfoNew {
  fileDate: string;
  fileID: number;
  fileName: string;
  groupID: number;
}

export interface IUpdateExpertise {
  documentDate: string;
  documentNumber: string;
  expertiseID: number;
  expertiseType: number;
  isActive: boolean;
  isIntegration: boolean;
  livingComplexID: number;
  regionID: number;
}

export interface IDictionary {
  id: number;
  title: string;
}

export interface IDownloadExpertiseFile {
  fileID: number;
  expertiseID: number;
  isKenml: boolean;
  remotePSD: boolean;
  fileName?: string;
  groupID?: number;
}

export interface IUploadExpertiseBody {
  livingComplexID: number;
  documentDate: string;
  documentNumber: number | any;
  expertiseType: number;
  isIntegration: boolean;
  isActive: boolean;
  file: File;
  fileExtension: string;
  expertiseID?: number;
  regionID: number;
}

export const CExpertiseResponseStringByCodeNumber = {
  null: 'Ошибки не',
  0: 'Заключения не существует',
  1: 'Заключение существует',
  2: 'Заключение аннулировано',
  3: 'Доступ запрещён',
  4: 'Файл не найден',
  5: 'Файл удалён',
  6: 'Сервис не доступен',
  7: 'Файловое хранилище не отвечает',
  8: 'Операция в базе не выполнена',
  9: 'Парсинг файлов не выполнен',
}

export interface ISampleSignInfo {
  serialNumber: string;
  orgUnitName: string;
  orgName: string;
  notAfter: string;
  allInfo: string;
  text?: string;
  bool?: boolean;
}

export interface IUploadSignedConsentPdfFileResult {
  authorConsentFileID: number;
  expertiseID: number;
  fileName: string;
  errorStatus: number;
  responseType: any;
}

export interface IUploadExpertiseRes {
  errorStatus: number;
  responseType: number;
  conclusionFileID?: number;
  expertiseID?: number;
}


export interface IMaterialFile {
  fileDate: string;
  fileID: number;
  fileName: string;
  groupID: ExpertiseGroupsEnum;
  isIntegration: boolean;
}
export interface IMaterialFileGroup {
  consentFileMessage: any;
  files: IMaterialFile[];
  message: string;
}


export enum ExpertiseGroupsEnum {
  // 1	согласие автора проекта
  // 3	заключение экспертизы
  // 5	файлы смет в электронно-цифровом формате (kenml)
  // 7	файлы ПСД
  Author = 1,
  Conclusion = 3,
  Kenml = 5,
  Psd = 7,
}

export interface IDeletePsdFile {
  fileID: number;
  expertiseID: number;
  isKenml: boolean;
  isPSOPortal: boolean;
}


export interface IUploadPsdFile {
  groupID: number;
  expertiseID: number;
  livingComplexID: number;
  isKenml: boolean;
  files: FileList;
  regionID: number;
}

export interface IUploadPsdFileResponse {
  fileName: string;
  fileDate: string;
  status: string;
}
